<template>
  <div class="backMoneyMain">
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="headerTitle">
          订单信息
        </div>
      </div>
      <div>
        <nut-cell title="订单编号" :desc="orderDetails.ordernumber"></nut-cell>
        <nut-cell title="用户名" :desc="orderDetails.userName"></nut-cell>
        <nut-cell title="订单类型" :desc="orderDetails.orderType"></nut-cell>
        <nut-cell
          title="充电时长"
          :desc="`${orderDetails.hour}小时`"
        ></nut-cell>
        <nut-cell title="消费金额" :desc="orderDetails.price"></nut-cell>
        <nut-cell title="充电桩编号"
          ><span slot="desc"
            ><el-input
              @input="
                formDataPort.parkId > 8
                  ? (formDataPort.parkId = formDataPort.parkId.slice(0, 8))
                  : formDataPort.parkId
              "
              type="number"
              class="input-box"
              v-model="formDataPort.parkId"
              placeholder="请输入"
            ></el-input></span
        ></nut-cell>
        <nut-cell title="端口号"
          ><span slot="desc"
            ><el-input
              @input="
                formDataPort.portCode > 3
                  ? (formDataPort.portCode = formDataPort.portCode.slice(0, 3))
                  : formDataPort.portCode
              "
              type="number"
              placeholder="请输入"
              class="input-box"
              v-model="formDataPort.portCode"
            ></el-input></span
        ></nut-cell>
        <nut-cell class="buttons">
          <span slot="title" class="orderDetailButton" @click="cancel()"
            >取消</span
          >
          <span
            slot="desc"
            class="orderDetailButton"
            @click="confimchangeportHandler()"
            >提交</span
          >
        </nut-cell>
      </div>
    </el-card>
  </div>
</template>
<script>
import { getOrderDetails } from "@/api/newApi";
export default {
  data() {
    return {
      ordernumber: "",
      formDataPort: {
        orderId: "",
        parkId: "",
        portCode: "",
      },
      orderDetails: {},
    };
  },
  mounted() {
    this.ordernumber = this.$route.query.ordernumber;
    this.token = window.localStorage.getItem("token");
    getOrderDetails({ orderNumber: this.ordernumber, token: this.token }).then(
      (res) => {
        this.orderDetails = res.data;
      }
    );

    console.log(this.ordernumber);
  },
  methods: {
    cancel() {
      this.$router.push({
        path: "/admin/order",
      });
    },
    confimchangeportHandler() {
      this.formDataPort.orderId = orderDetails.id;
      if (this.formDataPort.portCode == "") {
        Toast("请输入充电桩端口号");
        return;
      }
      if (this.formDataPort.parkId == "") {
        Toast("请输入充电桩编号");
        return;
      }

      this.$api.changePort(this.formDataPort).then((res) => {
        console.log(res);
        debugger;
        if (res.data.message.code != 0) {
          Toast(res.data.message.message);
        } else {
          Toast("操作成功");
          this.changeportShow = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.backMoneyMain {
  padding: 0.2778rem;
  ::v-deep .el-input-number {
    padding-bottom: 0.1333rem;
    .el-input__inner {
      height: 0.8rem;
      padding-left: 0;
      padding-right: 10px;
      text-align: right;
    }
    .el-input-number__decrease {
      display: none;
    }
    .el-input-number__increase {
      display: none;
    }
  }

  .input-box {
    ::v-deep .el-input__inner {
      text-align: right;
    }
  }
  .headerTitle {
    text-align: center;
    color: $titleColor;
  }

  ::v-deep .el-card__body {
    padding: 0rem !important;
    background-color: transparent;
  }

  ::v-deep .el-card__header {
    background-color: transparent;
    border-bottom: 1px solid transparent;
    margin: 0 0.2083rem;
  }

  ::v-deep .nut-cell {
    background-color: transparent !important;
    border-bottom: 1px solid transparent;

    .nut-cell-title {
      color: $liteTitleColor;
      font-size: 0.35rem;
    }

    .nut-cell-desc {
      color: #455182;
      font-size: 0.35rem;
    }
  }

  ::v-deep .nut-cell-box,
  ::v-deep .nut-cell:last-of-type {
    background-image: none !important;
  }

  ::v-deep .el-card {
    border: 1px solid transparent !important;
    background-color: $cardColor;
  }

  .orderDetailButton {
    padding: 0.1389rem 0.4167rem;
    border: 1px solid $buttonColor;
    color: $buttonColor;
    border-radius: 0.0694rem;
    display: inline-block;
  }
  .buttons {
    ::v-deep .nut-cell-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      .nut-cell-left {
        margin-right: 0.4167rem;
      }
    }
  }
}
</style>
